import React from 'react';
interface DmpLogoProps {
  size?: number;
  className?: string;
}
const dmpLogoUrl = 'https://cdn.magicpatterns.com/uploads/7v1Sg4riyi7LgbKWH9PSfU/dhaka-metropolitan-police-seeklogo.png';
export function DmpLogo({
  size = 48,
  className
}: DmpLogoProps) {
  return <img src={dmpLogoUrl} alt="ঢাকা মেট্রোপলিটন পুলিশ লোগো" width={size} height={size} className={`object-contain ${className ?? ''}`} data-id="element-698" data-mp="dqvroqdafll" />;
}